export const dugoutThemes = ['forest', 'paper', 'night-game'] as const
export type DugoutTheme = typeof dugoutThemes[number]
let current: DugoutTheme = 'forest'
let persistPreference = true
const listeners = new Set<() => void>()
export const subscribeTheme = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener) } }
export const getTheme = () => current
export const serverTheme = (): DugoutTheme => 'forest'
const isTheme = (value: string | null): value is DugoutTheme => dugoutThemes.some(theme => theme === value)

export function syncPageTheme() {
  const paper = current === 'paper'
  document.documentElement.dataset.dugoutTheme = current
  for (const node of document.querySelectorAll<HTMLElement>('.dugout-site,.learn-root,.dugout-redesign,.ds-page')) node.dataset.theme = paper ? 'paper' : 'forest'
  document.querySelector('.work-page')?.classList.toggle('work-forest', !paper)
  document.querySelector('.services-site')?.classList.toggle('services-forest', !paper)
}

export function setDugoutTheme(theme: DugoutTheme) {
  current = theme
  try { if (persistPreference) localStorage.setItem('dugout-theme', theme) } catch { /* Browsing without storage still supports theme selection. */ }
  const url = new URL(location.href)
  url.searchParams.delete('theme')
  history.replaceState(history.state, '', url)
  syncPageTheme()
  listeners.forEach(listener => listener())
}

export function initializeDugoutTheme() {
  const params = new URLSearchParams(location.search)
  persistPreference = params.get('typeEmbed') !== '1'
  const query = params.get('theme')
  let saved: string | null = null
  try { saved = localStorage.getItem('dugout-theme') } catch { /* Default to Forest. */ }
  current = isTheme(query) ? query : isTheme(saved) ? saved : 'forest'
  if (persistPreference && isTheme(query)) { try { localStorage.setItem('dugout-theme', query) } catch { /* Keep the URL-selected theme for this page. */ } }
  document.documentElement.dataset.dugoutTheme = current
  new MutationObserver(syncPageTheme).observe(document.getElementById('root')!, { childList: true, subtree: true })
  window.addEventListener('storage', event => {
    if (!persistPreference || event.key !== 'dugout-theme') return
    current = isTheme(event.newValue) ? event.newValue : 'forest'
    syncPageTheme()
    listeners.forEach(listener => listener())
  })
}
